import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { QueryClient, QueryClientProvider as ReactQueryProvider } from '@tanstack/react-query';
import { CurrentUserContextProvider } from '../../../users/contexts/CurrentUserContext';
let queryClientSingleton: QueryClient;
function getQueryClient(): QueryClient {
  if (!queryClientSingleton) {
    queryClientSingleton = new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          retry: 1
        }
      }
    });
  }
  return queryClientSingleton;
}
function DataConnectProvider(t0) {
  const $ = _c(6);
  const {
    children,
    withoutUserContext: t1
  } = t0;
  const withoutUserContext = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = getQueryClient();
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const queryClient = t2;
  const withUserContext = !withoutUserContext;
  let t3;
  if ($[1] !== children || $[2] !== withUserContext) {
    t3 = withUserContext ? <CurrentUserContextProvider>{children}</CurrentUserContextProvider> : children;
    $[1] = children;
    $[2] = withUserContext;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <ReactQueryProvider client={queryClient}>{t3}</ReactQueryProvider>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}
export default DataConnectProvider;